import apiClient from './api';
import type { SystemSettings } from '../types';
import { normalizeFileUrl } from './fileService';

export interface SystemSettingsResponse extends SystemSettings {
  id?: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getSystemSettings = async (): Promise<SystemSettingsResponse> => {
  const response = await apiClient.get<SystemSettingsResponse>('/system-settings');
  return response.data;
};

export const saveSystemSettings = async (data: SystemSettings): Promise<SystemSettingsResponse> => {
  const response = await apiClient.put<SystemSettingsResponse>('/system-settings', data);
  return response.data;
};

const ensureLinkElement = (selector: string, rel: string) => {
  let link = document.querySelector<HTMLLinkElement>(selector);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  return link;
};

export const applySystemSettingsBrand = (settings: Partial<SystemSettings>) => {
  if (settings.siteName) {
    document.title = settings.siteName;
  }

  const logoUrl = normalizeFileUrl(settings.logo);
  const iconUrl = logoUrl || `${process.env.PUBLIC_URL || ''}/favicon.ico`;
  const favicon = ensureLinkElement("link[rel='icon']", 'icon');
  favicon.href = iconUrl;

  const appleIcon = ensureLinkElement("link[rel='apple-touch-icon']", 'apple-touch-icon');
  appleIcon.href = logoUrl || `${process.env.PUBLIC_URL || ''}/logo192.png`;
};
